import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";

const Info = ({ item }) => {
  let gtexGeneModel;
  let gencodeGene;
  let gtexGeneModelStart;

  if (
    item &&
    !isEmpty(item.gene_model_positions) &&
    item.gene_model_positions !== null
  ) {
    gtexGeneModelStart = item.gene_model_positions.start;
    gtexGeneModel = (
      <div>
        <b> Gene model from GTEx: </b>
        {item.gene_model_positions.chromosome}
        {", locations "}
        {item.gene_model_positions.start}
        {" - "}
        {item.gene_model_positions.end}
        {item.gene_model_positions.strand &&
          (item.gene_model_positions.strand === "+"
            ? ", possitive strand"
            : ", negative strand")}
      </div>
    );
  }

  if (
    item &&
    !isEmpty(item.gene_positions) &&
    item.gene_positions !== null &&
    gtexGeneModelStart !== item.gene_positions.start
  ) {
    gencodeGene = (
      <div>
        <b>VS Gene from GENCODE: </b>
        {item.gene_positions.chromosome}
        {", locations "}
        {item.gene_positions.start}
        {" - "}
        {item.gene_positions.end}
        {item.gene_positions.strand &&
          (item.gene_positions.strand === "+"
            ? ", possitive strand"
            : ", negative strand")}
      </div>
    );
  }

  return (
    <div className="tw-mb-4">
      {gtexGeneModel}
      {gencodeGene}
    </div>
  );
};

Info.propTypes = {
  item: PropTypes.shape({
    gene_model_positions: PropTypes.shape({
      strand: PropTypes.string,
      start: PropTypes.number,
      chromosome: PropTypes.string,
      end: PropTypes.number,
    }),
    gene_positions: PropTypes.shape({
      strand: PropTypes.string,
      start: PropTypes.number,
      chromosome: PropTypes.string,
      end: PropTypes.number,
    }),
  }),
};

Info.defaultProps = {
  item: null,
};

export default Info;
